<template>
  <div>
    <a-spin size="large" :spinning="spinning">
      <a-row style='background-color:white'>
        <a-card :bordered="false" :title="$t('message.card.fulfillment.fulfillmentOrderId') + ' : ' + $route.query.orderFulfillmentOrderId" >
          <a-steps size="small" :current="this.currentNode" class="a-step-container">
            <template v-for="node in processNodes">
              <a-step :title="node.stepMessage" />
            </template>
          </a-steps>
        </a-card>
      </a-row>

      <a-row style='background-color:white'>
        <a-col :span="20">
          <a-card :bordered="false" :title="$t('message.card.fulfillment.orderInformation')" id="order-information">
            <a-descriptions bordered>
              <a-descriptions-item :label="$t('message.card.fulfillment.tradeOrderId')">
                {{this.orderDetails.tradeOrderId}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.orderStatus')">
                {{this.orderDetails.orderStatusDesc}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.warehouseCode')">
                {{this.orderDetails.warehouseCode}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.warehouseName')">
              {{this.orderDetails.warehouseName}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.buyerName')">
                {{this.orderDetails.buyerName}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.buyerId')">
                {{this.orderDetails.buyerId}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.tradeCreateTime')">
                {{this.orderDetails.tradeCreateTime}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.tradePayTime')">
                {{this.orderDetails.tradePayTime}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.shipperId')">
                {{this.orderDetails.orderOwnerId}}
              </a-descriptions-item>
            </a-descriptions>
          </a-card>

          <a-card :bordered="false" :title="$t('message.card.fulfillment.receiverInfomation')" id="receiver-information">
            <a-descriptions bordered>
              <a-descriptions-item :label="$t('message.card.fulfillment.receiverName')">
                {{this.orderDetails.receiverName}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.receiverMobile')">
                {{this.orderDetails.receiverMobile}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.receiverPhone')">
                {{this.orderDetails.receiverPhone}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.receiverZip')">
                {{this.orderDetails.receiverZip}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.receiverCountry')">
                {{this.orderDetails.receiverCountry}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.receiverProvince')">
                {{this.orderDetails.receiverProvince}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.receiverCity')">
                {{this.orderDetails.receiverCity}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.receiverAddress')">
                {{this.orderDetails.receiverAddress}}
              </a-descriptions-item>
            </a-descriptions>
          </a-card>

          <a-card :bordered="false" :title="$t('message.card.fulfillment.deliveryInfomation')" id="delivery-information">
            <a-descriptions bordered>
              <a-descriptions-item :label="$t('message.card.fulfillment.trackingNumber')">
                {{this.orderDetails.trackingNumber}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.shippingServiceCode')">
                {{this.orderDetails.shippingServiceCode}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.shippingProviderName')">
                {{this.orderDetails.shippingProviderName}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.promiseEarliestDate')">
                {{this.orderDetails.promiseEarliestDate}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.promiseLatestDate')">
                {{this.orderDetails.promiseLatestDate}}
              </a-descriptions-item>
            </a-descriptions>
          </a-card>

          <a-card :bordered="false" :title="$t('message.card.fulfillment.itemInfomation')" id="item-infomation1">
            <a-table :columns="columns" :dataSource="dataSource" bordered :scroll="{ x: 1200 }">
            </a-table>
          </a-card>
        </a-col>

        <a-col :span="4">
          <a-anchor>
            <a-anchor-link href="#order-information" :title="$t('message.card.fulfillment.orderInformation')" />
            <a-anchor-link href="#receiver-information" :title="$t('message.card.fulfillment.receiverInfomation')" />
            <a-anchor-link href="#delivery-information" :title="$t('message.card.fulfillment.deliveryInfomation')" />
            <a-anchor-link href="#item-infomation1" :title="$t('message.card.fulfillment.itemInfomation')" />
          </a-anchor>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>

import {OrderApi} from '../../js/OrderApi'
import request from '../../utils/request'

export default {
  computed: {
    columns () {
      return [
        {
          title: this.$t('message.table.fulfillment.itemId'),
          width: 150,
          dataIndex: 'itemId',
          fixed: 'left'
        },
        {
          title: this.$t('message.table.fulfillment.scItemId'),
          width: 150,
          dataIndex: 'scItemId'
        },
        {
          title: this.$t('message.table.fulfillment.itemName'),
          width: 150,
          dataIndex: 'itemName'
        },
        {
          title: this.$t('message.table.fulfillment.itemQuantity'),
          width: 100,
          dataIndex: 'orderLineQty'
        },
        {
          title: this.$t('message.table.fulfillment.itemActualPaidFee'),
          width: 150,
          dataIndex: 'itemActualPaidAmount'
        },
        {
          title: this.$t('message.table.fulfillment.itemDiscountFee'),
          width: 150,
          dataIndex: 'itemDiscountAmount'
        },
        {
          title: this.$t('message.table.fulfillment.itemTaxActualFee'),
          width: 150,
          dataIndex: 'itemTaxActualFee'
        },
        {
          title: this.$t('message.table.fulfillment.itemShippingActualPaidFee'),
          width: 150,
          dataIndex: 'itemShippingActualPaidAmount'
        },
        {
          title: this.$t('message.table.fulfillment.unitPrice'),
          width: 150,
          dataIndex: 'unitPrice',
          fixed: 'right'
        }
      ]
    }
  },
  data () {
    return {
      processNodes: [],
      merchantCode: '',
      status: 0,
      detailTitle: '',
      currentNode: 0,
      orderDetails: null,
      rowKey: 'id',
      dataSource: this.dataSource,
      selectedRowKeys: [], // Check here to configure the default column,
      orderFulfillmentOrderId: '',
      orderSiteId: '',
      spinning: false
    }
  },
  created () {
    this.orderFulfillmentOrderId = this.$route.query.orderFulfillmentOrderId
    this.orderSiteId = this.$route.query.orderSiteId
    this.merchantCode = this.$route.query.merchantCode
    this.detailTitle = this.$t('message.card.fulfillment.fulfillmentOrderId') + ' : ' + this.orderFulfillmentOrderId
    this.queryOrderDetails(this.orderFulfillmentOrderId, this.orderSiteId)
  },
  methods: {
    onChange (date, dateString) {
    },
    queryProcessNode (merchantCode, status) {
      request({
        url: OrderApi.OrderFromUrl.queryFulfillmentStatusSteps,
        method: 'get',
        // headers:{
        //   requestUserId:InboundApi.requestUserId
        // },
        params: {
          merchantCode: merchantCode,
          status: status
        }
      }).then(response => {
        console.log(response.data.data)
        this.processNodes = response.data.data.fulfillmentStatusSteps
        this.currentNode = response.data.data.currentNode
        console.log(this.currentNode)
      })
    },

    queryOrderDetails (orderFulfillmentOrderId, orderSiteId) {
      this.spinning = true;
      request({
        url: OrderApi.OrderFromUrl.queryFulfillmentOrderDetailsUrl,
        method: 'get',
        params: {
          orderFulfillmentOrderId: orderFulfillmentOrderId,
          orderSiteId: orderSiteId
        }
      }).then(response => {
        if (response.data.success) {
          this.orderDetails = response.data.data[0]
          this.status = response.data.data[0].orderStatus
          this.dataSource = response.data.data
        } else {
          this.$message.error(response.data.errorMsg)
        }
        this.spinning = false
        this.queryProcessNode(this.merchantCode, this.status)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Fulfillment/OrderDetail.vue